module.exports = __webpack_public_path__ + "static/media/douglas-fernandes.00b4bf57.png";